
import Picture from '~/components/picture/lole-picture.vue'
import Button from '~/components/buttons/Button.vue'
export default {
  components: { Picture, Button },
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
}
